import { DashboardItem } from 'src/types/dashboard'

export const haveItemsChanged = (
  original: DashboardItem[] | undefined | null,
  current: DashboardItem[] | undefined | null
): boolean => {
  if (!original?.length && !current?.length) return false
  if (original?.length !== current?.length) return true
  return JSON.stringify(original) !== JSON.stringify(current)
}
